import { render, staticRenderFns } from "./PalletBalance.vue?vue&type=template&id=992ea66e"
import script from "./PalletBalance.vue?vue&type=script&lang=js"
export * from "./PalletBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports